export default __webpack_public_path__ + "static/media/promocionAlarma5.17f4b23f.png";